export const defaultTheme = {
  // grayscale
  white: '#FFFFFF',
  grayExtraLight: '#FCFDFE',
  grayBackground: '#F7F8FC',
  grayLightest: '#F0F1F7',
  grayDividerGraph: '#EBEDF0',
  grayDivider: '#DFE0EB',
  grayLight: '#C5C7CD',
  gray: '#9FA2B4',
  grayDark: '#4B506D',
  black: '#252733',
  modalOverlay: '#2527334d',

  yellow: '#FEA500',
  orange: '#FFA600',
  green: '#00DA8B',
  blue: '#018EFF',
  blueDark: '#253DD9',
  purple: '#9A53CB',
  accentLightest: '#DDE2FF',
  accentLight: '#253DD9',
  accent: '#253292',
  pink: '#FF4EA1',
  pinkLight: '#FF81BC',
  pastelPink: '#F4BDE7',
  red: '#FE2142',

  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1050px',
    xxl: '1150px',
    xxxl:'1400px'
  }
} as const
